import { GliderFileType } from '@/enum/GliderFileType'
import { IAloBaseArray, AloBaseArray } from './AloBaseArray';

export class AloGliderFileShort {
  public gliderFileType: GliderFileType | null
  public targetYosCycle: number | null
  public dataProgression: number | null
  public isDownloadable: boolean
  public isRunning: boolean

  constructor({ gliderFileType, targetYosCycle, dataProgression,isDownloadable,isRunning}: {gliderFileType: GliderFileType | null,targetYosCycle: number | null,dataProgression: number | null, isDownloadable:boolean, isRunning:boolean}) {
    this.gliderFileType = gliderFileType
    this.targetYosCycle = targetYosCycle
    this.dataProgression = dataProgression
    this.isDownloadable = isDownloadable
    this.isRunning = isRunning
  }  

  static createAloGliderFileShortArray(data: IAloBaseArray) {
    return new AloBaseArray(AloGliderFileShort,data)
  }
}
